import { Contract as EthersContract, getAddress } from "ethers";
import { EthereumAddress } from "./address";
/**
 * Ethers-based contract implementation.
 */
export class EthersContractWrapper {
    /**
     * Ethers instance of the deployed contract.
     */
    instance;
    /**
     * Address of this contract instance.
     */
    #address;
    constructor(config, deployment) {
        const contractAddress = config.address ?? getAddress(deployment.address);
        this.instance = new EthersContract(contractAddress, `${JSON.stringify(deployment.abi)}`, config.runner);
        this.#address = contractAddress;
    }
    /**
     * Get address of the contract instance.
     * @returns Address of this contract instance.
     */
    getAddress() {
        return EthereumAddress.from(this.#address);
    }
}
//# sourceMappingURL=contract.js.map